export default __webpack_public_path__ + "static/media/disenocerrado.0e1125f9.svg";